<script setup>
  import { useFieldValueRenderer } from '@/features/settingsManagement/fieldManagement/edit/plugin/useFieldValueRenderer.js'
  import { fieldCommonProps } from '@/features/settingsManagement/fieldManagement/edit/utils/fieldUtils.js'

  defineProps({
    field: fieldCommonProps.field,
  })

  const { fieldTemplateRendererComponent } = useFieldValueRenderer()
</script>

<template>
  <template v-if="fieldTemplateRendererComponent">
    <component :is="fieldTemplateRendererComponent" :label="field.key">
      <slot />
    </component>
  </template>

  <div
    v-else
    class="field-value-renderer"
    :data-field-key="field.key"
    :data-field-key-type="field.keyType"
  >
    <slot name="field-value-renderer-slot">
      <label class="field-value-renderer-label" :for="field.key">
        <slot name="label" />
      </label>

      <div class="field-value-renderer-slot">
        <slot />
      </div>
    </slot>
  </div>
</template>

<style lang="scss" scoped>
  .field-value-renderer {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .field-value-renderer-label {
    font-weight: bold;
  }
</style>
